import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { parsePaginatedResponse } from "../../utils/parsePaginatedResponse";

const CASE_STUDY_KEYS = ["caseStudies", "caseStudy"];

export const useViewCaseStudyQuery = ({ page, limit, q } = {}) => {
  const isPaginated = page !== undefined && limit !== undefined;
  const trimmedQ = q?.trim?.() ?? "";

  return useQuery({
    queryKey: isPaginated
      ? ["viewCaseStudy", page, limit, trimmedQ]
      : ["viewCaseStudy"],
    queryFn: async () => {
      const params = {};
      if (isPaginated) {
        params.page = page;
        params.limit = limit;
        if (trimmedQ) params.q = trimmedQ;
      }

      const res = await api.get("/case-study/list", { params });

      if (isPaginated) {
        const parsed = parsePaginatedResponse(res.data, CASE_STUDY_KEYS, limit);
        return {
          caseStudies: parsed.items,
          pagination: parsed.pagination,
        };
      }

      return res.data;
    },
    placeholderData: isPaginated
      ? (previousData) => previousData
      : undefined,
    staleTime: isPaginated ? 60_000 : undefined,
  });
};
